import type { UniversalModifierValue } from "schemas/generated/fileModifiers";

import React from "react";

import { AssetModifier } from "./base/AssetModifier";
import BorderModifier from "./base/BorderModifier";
import HeightModifier from "./base/HeightModifier";
import MarginModifierComponent from "./base/MarginModifier";
import ShadowModifierComponent from "./base/ShadowModifier";
import WidthModifier from "./base/WidthModifier";
import ModifierLayout from "./ModifierLayout";
import { useDefaultSelectedElementDesignation } from "./store/ModifiersStoreContext";

interface ImageModifierBlockProps {
  onModifiersValueChange: (
    modifiers: UniversalModifierValue[],
    byteOffset: number,
  ) => void;
}

const ImageModifierBlock: React.FC<ImageModifierBlockProps> = ({
  onModifiersValueChange,
}) => {
  const defaultDesignation = useDefaultSelectedElementDesignation();

  if (!defaultDesignation) {
    return null;
  }

  const sections = [
    {
      rows: [
        {
          title: "Media",
          component: (
            <AssetModifier
              onAssetChange={(assetSource) => {
                onModifiersValueChange(
                  [{ type: "asset", source: assetSource ?? "" }],
                  defaultDesignation.element.byteOffset,
                );
              }}
            />
          ),
        },
      ],
    },
    {
      rows: [
        {
          title: "Width",
          component: (
            <WidthModifier
              onChange={(modifiers) => {
                onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.byteOffset,
                );
              }}
            />
          ),
        },
        {
          title: "Height",
          component: (
            <HeightModifier
              onChange={(modifiers) => {
                onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.byteOffset,
                );
              }}
            />
          ),
        },
      ],
    },
    {
      rows: [
        {
          title: "Margin",
          component: (
            <MarginModifierComponent
              onChange={(modifiers) => {
                onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.byteOffset,
                );
              }}
            />
          ),
        },
      ],
    },
    {
      rows: [
        {
          title: "Border",
          component: (
            <BorderModifier
              onChange={(modifiers) => {
                onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.byteOffset,
                );
              }}
            />
          ),
        },
        {
          title: "Shadow",
          component: (
            <ShadowModifierComponent
              onChange={(modifiers) => {
                onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.byteOffset,
                );
              }}
            />
          ),
        },
      ],
    },
  ];

  return (
    <ModifierLayout
      sections={sections}
      onModifiersValueChange={onModifiersValueChange}
    />
  );
};

export default ImageModifierBlock;
